import { createTheme } from '@mui/material';

import typography from './typography';
import palette from './palette';
import components from './components';
import shadows from './shadows';

declare module '@mui/material/styles' {
  interface Theme {
    elevation: typeof shadows;
  }
  interface ThemeOptions {
    elevation: typeof shadows;
  }
}

const theme = createTheme({
  palette,
  typography,
  components,
  /**
   * Specific shadows according to Diagonal's elevation system
   */
  elevation: shadows,
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
});

export default theme;
